import { Tag } from "antd"
import { useTranslation } from "react-i18next"

import styles from "./badges.module.less"

// "attention" / "review" read as bad, "none" as good (DAA-4-09, DAA-4-16).
const TAG_COLOR = {
  attention: "error",
  review: "error",
  none: "success"
}

// A KPI's status rather than its change: "attention" / "review" when there is something to look
// at, "none" when not (Lost merchants, New values in period). Stays with Do not compare (DAA-2-22).
const StatusBadge = ({ status }) => {
  const { t } = useTranslation()

  return (
    <Tag color={TAG_COLOR[status]} className={styles.badge}>
      {t(status)}
    </Tag>
  )
}

export default StatusBadge
